import { DateHelper, isArray, SessionStorageHelper, createDate } from "@parksandresorts/core";
import { ServiceHelper } from "components/helpers/index";
class JetshopProductService {
  getProducts(culture = "", currency = "") {
    return ServiceHelper.fetchGet(`webshop/products/${culture}/${currency}`.toLowerCase());
  }

  getProductsCalendar(glkId) {
    const key = `JetshopProductService-getProductsCalendar-${glkId}`;
    const response = SessionStorageHelper.getItem(key);
    if (response) {
      return Promise.resolve(response);
    }

    return ServiceHelper.fetchGet(`productscalendar/${glkId}`.toLowerCase()).then((response) => {
      const timeStampDate = DateHelper.addMinutes(createDate(), 1);
      SessionStorageHelper.setItem(key, response, timeStampDate.getTime());
      return Promise.resolve(response);
    });
  }

  getMultiProductsCalendar(glkIds, baseProductOnly = false) {
    if (!isArray(glkIds)) {
      return Promise.reject("glkIds must be array with at least one item");
    }

    const key = `JetshopProductService-getMultiProductsCalendar-[${glkIds.toString()}]`;
    const response = SessionStorageHelper.getItem(key);
    if (response) {
      return Promise.resolve(response);
    }

    const glkIdsString = glkIds.join(",");

    return ServiceHelper.fetchGet(
      `productscalendar-multi/${glkIdsString}?baseProductOnly=${baseProductOnly}`.toLowerCase()
    ).then((response) => {
      const timeStampDate = DateHelper.addMinutes(createDate(), 1);
      SessionStorageHelper.setItem(key, response, timeStampDate.getTime());
      return Promise.resolve(response);
    });
  }
}

const helper = new JetshopProductService();
export default helper;
